import { useEffect, useState, useContext } from 'react'
import './project.less'
import { ReactComponent as LogoSvg } from './icons/logo.svg';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { LogoutOutlined } from '@ant-design/icons';
import { ReactComponent as BackSvg } from '@/baseui/c1/icons/back.svg';

import { getProject } from '@/declare/api/project';
import localStore from '@/store/local-store';
import { PROJECT_CATEGORY } from '@/declare/enums/project-category';
import { SystemStatus } from '@/store/system-store';
import { SystemContext } from '@/App';
import { StdWsPack, WorkflowNotice } from '@/declare/interface/notice';
import { WsType } from '@/declare/enums/ws-type';
import { EMITTER_TYPE, emitter } from '@/store/mitt';
import { Tooltip } from 'antd';
import { getToolListByProjectCategory } from '@/declare/enums/tool-type';
import { userCheckLogin } from '@/declare/api/user';
import { User } from '@/declare/interface/user';
import MeetingMinutePanel from '@/panel/meeting-record';
import { UserFeedbackActiveBtn } from '@/components/user-feedback';


interface ProjectProps {
    type: PROJECT_CATEGORY,
    feedbackVisible: boolean,
    changeFeedbackVisible: (value: boolean) => void
}

export default function ProjectLayout(props: ProjectProps) {
    const { feedbackVisible, changeFeedbackVisible } = props;
    const navigate = useNavigate();
    const systemContext = useContext<SystemStatus>(SystemContext);
    const { projectId, institutionId } = useParams();
    const location = useLocation();

    const [currentProjectId, setCurrentProjectId] = useState<string>('');
    const [currentProjectName, setCurrentProjectName] = useState<string>('');

    /**
     * 背景主题色，暂时根据类型写死，后续可考虑用户定义
     */
    const [backColor, setBackColor] = useState<string>('#f3f5f7');


    /**
     * 修改背景色
     */
    useEffect(() => {
        if (props.type === PROJECT_CATEGORY.PERSONAL) {
            // 个人
            setBackColor('#F3F5F7');
        } else if (props.type === PROJECT_CATEGORY.INSITITUTION) {
            // 机构
            setBackColor('#CEE0F5');
        } else {
            setBackColor('#D9EEEF');
        }

    }, [props.type])

    /**
     * 监听websocket发来的消息
     */
    useEffect(() => {
        setTimeout(() => {
            if (systemContext.rws != null) {
                systemContext.rws.onmessage = wsMsg;
            }
        }, 0);
    }, [systemContext.rws, projectId])

    /**
     * 监听工作流更新
     * @param value 
     * @returns 
     */
    const wsMsg = (value) => {
        const body: StdWsPack<any> = JSON.parse(value.data);
        if (body.type == WsType.WORKFLOW) {
            let notice: WorkflowNotice = body.data;
            if (notice.data == 'UPDATE') {
                // 工作流有更新 发送信号
                emitter.emit(EMITTER_TYPE.WORKFLOW_UPDATE, notice.type);
            }
        } else if (body.type == WsType.MEETING) {
            emitter.emit(EMITTER_TYPE.MEETING_STATUS_UPDATE, "");
        } else if (body.type == WsType.PROFILE_ANALYSIS) {
            emitter.emit(EMITTER_TYPE.PROFILE_UPDATE, body.data);
        }
    }

    /**
     * 根据路由查询项目信息或者机构信息
     */
    useEffect(() => {

        // 根据userId查询个人项目
        userCheckLogin()
            .then(res => {
                let userDetail: User = res.data;
                if (userDetail.userProject) {
                    localStore.userProjectId = userDetail.userProject.id;
                    setCurrentProjectId(userDetail.userProject.id ? "" : userDetail.userProject.id.toString());
                }
            }).catch(err => {
            })
    }, [])

    /**
     * 跳转相对路径
     * @param path 
     */
    const goToUrl = (path) => {
        if (!path && props.type !== PROJECT_CATEGORY.LIBRARY) {
            // return;
            path = 'meeting-record'
        }
        //0.获取当前路由
        const route = location.pathname;
        localStore.currentUrl = path;
        localStore.setLastUrl(+currentProjectId, localStore.currentUrl);
        //1.匹配是否是我的页面
        const ownRegex = /^(\/own)/;
        let matchResult = route.match(ownRegex);
        if (matchResult) {//匹配成功
            // console.log(`${route} 匹配成功，匹配到的字符串是: ${matchResult[0]}`);
            navigate(`${matchResult[0]}/${path}`);
            return;
        }

        //2.匹配是否是机构页面
        const institutionsRegexWithTrailing = /^.*?(\/institutions\/[^\/]+)/;
        matchResult = route.match(institutionsRegexWithTrailing);
        if (matchResult) {
            // console.log(`${route} 匹配成功，提取到的字符串是: ${matchResult[1]}`);
            navigate(`${matchResult[1]}/${path}`);
            return;
        } else {
            // 若没有匹配到，则尝试匹配 /institutions 为最后一部分的情况
            const regexEnding = /^.*?(\/institutions)$/;
            matchResult = route.match(regexEnding);
            if (matchResult) {
                // console.log(`${route} 匹配成功，提取到的字符串是: ${matchResult[1]}`);
                // if (RsToolProject[path] && !RsToolProject[path].includes(PROJECT_CATEGORY.INSITITUTION)) {
                //     //没有该工具，直接返回
                //     return;
                // }
                navigate(`${matchResult[1]}/${path}`);
                return;
            }
        }

        //3.匹配是否是项目页面
        const projectRegexWithTrailing = /^.*?(\/projects\/[^\/]+)/;
        matchResult = route.match(projectRegexWithTrailing);
        if (matchResult) {
            console.log(`${route} 匹配成功，提取到的字符串是: ${matchResult[1]}`);
            // if (RsToolProject[path] && !RsToolProject[path].includes(PROJECT_CATEGORY.PROJECT)) {
            //     console.log("PROJECT 没有该工具，直接返回", "path", path, "RsToolProject[path]", RsToolProject[path], "PROJECT_CATEGORY.PROJECT", PROJECT_CATEGORY.PROJECT, (RsToolProject[path]).includes()[PROJECT_CATEGORY.PROJECT])
            //     //没有该工具，直接返回
            //     return;
            // }
            navigate(`${matchResult[1]}/${path}`);
            return;
        } else {
            // 若没有匹配到，则尝试匹配 /institutions 为最后一部分的情况
            const regexEnding = /^.*?(\/projects)$/;
            matchResult = route.match(regexEnding);
            if (matchResult) {
                console.log(`${route} 匹配成功，提取到的字符串是: ${matchResult[1]}`);
                // if (RsToolProject[path] && !RsToolProject[path].includes(PROJECT_CATEGORY.PROJECT)) {
                //     //没有该工具，直接返回
                //     return;
                // }
                navigate(`${matchResult[1]}/${path}`);
                return;
            }
        }

        // 5.匹配是否是库页面
        const libraryRegexWithTrailing = /^(\/library)/;
        matchResult = route.match(libraryRegexWithTrailing);
        if (matchResult) {
            console.log(`${route} 匹配成功，提取到的字符串是: ${matchResult[1]}`);
            // if (RsToolProject[path] && !RsToolProject[path].includes(PROJECT_CATEGORY.LIBRARY)) {
            //     console.log("PROJECT 没有该工具，直接返回", "path", path, "RsToolProject[path]", RsToolProject[path], "PROJECT_CATEGORY.PROJECT", PROJECT_CATEGORY.LIBRARY, (RsToolProject[path]).includes()[PROJECT_CATEGORY.LIBRARY])
            //     //没有该工具，直接返回
            //     return;
            // }
            if (!path) {
                navigate(`${matchResult[1]}`);
                return;
            }
            navigate(`${matchResult[1]}/${path}`);
            return;
        } else {
            // 若没有匹配到，则尝试匹配 /institutions 为最后一部分的情况
            const regexEnding = /^.*?(\/library)$/;
            matchResult = route.match(regexEnding);
            if (matchResult) {
                console.log(`${route} 匹配成功，提取到的字符串是: ${matchResult[1]}`);
                // if (RsToolProject[path] && !RsToolProject[path].includes(PROJECT_CATEGORY.LIBRARY)) {
                //     //没有该工具，直接返回
                //     return;
                // }
                navigate(`${matchResult[1]}/${path}`);
                return;
            }
        }
    }

    // 点击返回上一个路径
    const onClickBackLastUrl = () => {
        let goBackUrl = process.env.NODE_ENV === 'development' ? "http://localhost:3000" : "http://teamerp.tncet.com";
        window.location.href = goBackUrl;
    }

    const toolList = getToolListByProjectCategory(props.type, +institutionId)

    return (
        <div className='project-container' style={{ backgroundColor: backColor }}>
            <div className='header'>
                <div onClick={() => { }}>
                    <LogoSvg className='logo' />
                </div>
                <div className='user-panel'>
                    <Tooltip title="返回erp">
                        <BackSvg style={{ marginRight: 12, cursor: 'pointer' }}
                            onClick={onClickBackLastUrl} />
                    </Tooltip>
                    <Tooltip title="用户反馈" >
                        <UserFeedbackActiveBtn visible={feedbackVisible} changeVisible={(value) => changeFeedbackVisible(value)} />
                    </Tooltip>
                </div>
            </div>

            <div className='main-content'>
                <Routes>
                    {/* 会议纪要 */}
                    <Route path='meeting-record' element={<MeetingMinutePanel goToUrl={goToUrl} projectId={currentProjectId} projectName={currentProjectName} />} />
                    <Route path='meeting-record/:meetingId' element={<MeetingMinutePanel goToUrl={goToUrl} projectId={currentProjectId} projectName={currentProjectName} />} />
                </Routes >
            </div >
        </div >
    )
}
